var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.form.transportTipArr ? _c("a-modal", {
    attrs: {
      title: _vm.$t("priceStock.bundlingNote"),
      visible: _vm.visible,
      maskClosable: false
    },
    on: {
      ok: _vm.ok,
      cancel: _vm.cancel
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.form
    }
  }, [_vm._l(_vm.form.transportTipArr, function (tip, ti) {
    return [_c("a-form-model-item", {
      key: ti,
      attrs: {
        label: tip.title,
        prop: "transportTipArr." + ti + ".content",
        rules: [{
          required: tip.required,
          message: _vm.$t("priceStock.bundlingNoteTip"),
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("priceStock.bundlingNoteTip"),
        maxLength: 255,
        rows: 1
      },
      model: {
        value: tip.content,
        callback: function callback($$v) {
          _vm.$set(tip, "content", $$v);
        },
        expression: "tip.content"
      }
    })], 1)];
  })], 2)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };